/*  */

setup();
document.addEventListener("remount:login", remount);

function remount() {
  // Logical groupings of error states, update methods, and dom element references per input field
  var Email = {
    elem:document.querySelector("#input-email"),
    errors:false,
    update:function(andRender){
      Email.errors = ( Email.elem.value.length>4 && Email.elem.value.indexOf("@")!=-1 && Email.elem.value.indexOf(".")!=-1 ) ? false : ["Invalid email address"];
      if(andRender){Email.render();}
      return Email.errors;
    },
    render:function(){
      updateField( Email.errors, Email.elem.parentNode );
    }
  };

  var Password = {
    elem:document.querySelector("#input-password"),
    errors:false,
    update:function(andRender){
      Password.errors = (Password.elem.value.length > 0) ? false : ["Invalid password"];
      if(andRender){Password.render();}
      return Password.errors;
    },
    render:function(){
      updateField( Password.errors, Password.elem.parentNode );
    }
  };

  var Name = {
    elem:document.querySelector("label[for='input-name']"),
    render:function(){Name.elem.innerHTML = Email.elem.value;}
  };

  // when resuming interation with a field with errors, first hide any errors so if there are errors again after editing, it will be obvious that the errors are being re-displayed
  Email.elem.addEventListener("focus", function(){ Email.errors = false; Email.render(); });
  Password.elem.addEventListener("focus", function(){ Password.errors = false; Password.render(); });

  /*
  Initialize the phased form.
  1st argument: selector for the form element
  2nd argument: starting phase
  3rd argument: 'phase' object where the keys are the different phases, and the values are functions to be called when the form enters that phase.
  ...When the form enters a phase that matches a key, that function is called, with the form passed as the only argument.
  */
  FormPhaser("[data-login]", "email", {
    email:function(inForm){
      Email.elem.focus();
      inForm.submit = function(e){
        e.preventDefault();
        if(Email.update(true)){
          // do nothing
        }else{
          // continue to the password phase
          Password.errors = false; // clear the password error
          Password.render(); //
          Name.render(); // update the simplified name field
          inForm.phase("password");
        }
      };
    },
    password:function(inForm){
      Password.elem.focus();
      inForm.submit = function(e){
        if(Password.update(true)){
          // do nothing
          e.preventDefault();
        }else{
          // continue with form submission
          inForm.phase("processing");
        }
      };
    },
    processing:function(){
      var errors = document.querySelector("#error-overview");
      if(errors){ errors.style.display = "none"; }
    }
  });
}

function setup() {
  remount();
}

/*
Functions for updating display (assigning classes, style attributes, and manipulation of data attributes happen here).
These are pure functions that do not reference outside objects.
*/

// update field to show/hide errors
function updateField(inError, inElem){

  Array.prototype.slice.call(inElem.querySelectorAll(".login__tiptext--warn")).forEach(function(e){inElem.removeChild(e);});

  if(inError && inError.length){
    inError.forEach(function(){
      var span = document.createElement("span");
      span.innerHTML = inError;
      span.className = "login__tiptext login__tiptext--warn";
      inElem.appendChild(span);
    });
    inElem.classList.add("field--warn");
  } else {
    inElem.classList.remove("field--warn");
  }
}

// toggle display of form elements based on the form "phase"
function updateForm(inPhase, inElem){

  Array.prototype.slice.call((inElem||document).querySelectorAll("[data-login-phase-use]")).forEach(function(inItem){
      if ( inItem.getAttribute("data-login-phase-use")==inPhase ) {
        if (hasClass(inItem, 'hide-from-view')) removeClass(inItem, 'hide-from-view');
      } else {
        if (!hasClass(inItem, 'hide-from-view')) addClass(inItem, 'hide-from-view');
      }
  });

  return inPhase;
}

// A FormPhaser lets you switch out a form's submit and change handlers, and update element visibility (see updateForm).
// 'inPhases' argument is an object with keys
function FormPhaser(inSelector, inStartPhase, inPhases) {
  var Form = {
    phase:function(inPhase){
      var match;
      if(Form.active == inPhase){ return; }

      Form.active = updateForm(inPhase, Form.elem);

      match = Form.config[inPhase];
      if(!match){ return; }
      match(Form);
    },
    submit:function(){},
    change:function(){}
  };
  Form.elem = document.querySelector(inSelector);
  Form.elem.addEventListener("submit", function(e){ Form.submit(e); });
  Form.elem.addEventListener("change", function(e){ Form.change(e); });
  Form.elem.addEventListener("click",  function(e){
      // respond to phase-changing buttons
      var phase = e.target.getAttribute("data-login-phase-set");
      if(phase){
        Form.phase(phase);
        e.preventDefault();
      }
  });
  Form.config = inPhases;
  Form.phase(inStartPhase); // enter initial phase
  return Form;
}

// Helper functions for manipulating Class names
function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
}

function addClass(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!hasClass(el, className)) el.className += ' ' + className;
}

function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp('\\b'+ className+'\\b', 'g'), '');
}
